import {onFind} from "@elements/init-modules-in-scope";
import {findIn} from "@elements/dom-utils";

export function init() {
    onFind('.js-hero', function (hero) {
        let heroDesktop = findIn('.js-hero__desktop', hero);
        let heroMobile = findIn('.js-hero__mobile', hero);
        let heroVideo = findIn('.js-hero__video', hero);
        let viewportWidth = document.documentElement.clientWidth;

        if (heroVideo) {
            heroVideo?.classList.add('active');
            heroDesktop?.classList.remove('active');
            heroMobile?.classList.remove('active');
        } else {
            if (heroDesktop && heroMobile) {
                if (viewportWidth < 768) {
                    heroMobile?.classList.add('active');
                    heroDesktop?.classList.remove('active');
                } else {
                    heroDesktop?.classList.add('active');
                    heroMobile?.classList.remove('active');
                }
            } else if (heroDesktop && !heroMobile) {
                heroDesktop?.classList.add('active');
            }
        }
    });
}
